import {defineMessages} from 'react-intl';

export default defineMessages({
    Notes: {
        id: 'gateway.views.activity-detail.Notes',
        defaultMessage: 'Notes'
    },
    Documents: {
        id: 'gateway.views.cancellation-detail.Documents',
        defaultMessage: 'Documents'
    },
    Claims: {
        id: 'gateway.views.policy-detail-summary.Claims',
        defaultMessage: 'Claims'
    },
    searchTransactions: {
        id: 'gateway.views.policy-detail.Search Transactions',
        defaultMessage: 'Search Transactions'
    },
    Billing: {
        id: 'gateway.views.policy-detail-summary.Billing',
        defaultMessage: 'Billing'
    },
    Commission: {
        id: 'gateway.views.policy-detail-summary.Commission',
        defaultMessage: 'Commission'
    },
    Businessowners: {
        id: 'gateway.views.policy-detail-summary.Businessowners',
        defaultMessage: 'Businessowners'
    },
    JobNumber: {
        id: 'gateway.directives.policy-transaction.Job Number',
        defaultMessage: 'Job Number'
    },
    TransactionStatus: {
        id: 'gateway.directives.policy-transaction.Transaction Status',
        defaultMessage: 'Transaction Status'
    },
    Type: {
        id: 'gateway.directives.policy-transaction.Type',
        defaultMessage: 'Type'
    },
    Description: {
        id: 'gateway.directives.policy-transaction.Description',
        defaultMessage: 'Description'
    },
    PeriodStatus: {
        id: 'gateway.directives.policy-transaction.Period Status',
        defaultMessage: 'Period Status'
    },
    Premium: {
        id: 'gateway.directives.policy-transaction.Premium',
        defaultMessage: 'Premium ($)'
    },
    CoverageName: {
        id: 'gateway.directives.policy-transaction.Coverage Name',
        defaultMessage: 'Coverage Name'
    },
    CoverageLimit: {
        id: 'gateway.directives.policy-transaction.Limit',
        defaultMessage: 'Limit'
    },
    CoverageDeductible: {
        id: 'gateway.directives.policy-transaction.Deductible',
        defaultMessage: 'Deductible'
    },
    EffectiveDate: {
        id: 'gateway.directives.policy-transaction.Effective Date',
        defaultMessage: 'Effective Date'
    },
    CancelPolicy: {
        id: 'gateway.views.policy-detail-summary.Cancel Policy',
        defaultMessage: 'Cancel Policy'
    },
    ChangePolicy: {
        id: 'gateway.views.policy-detail-summary.Change Policy',
        defaultMessage: 'Change Policy'
    },
    RenewPolicy: {
        id: 'gateway.views.policy-detail-summary.Renew Policy',
        defaultMessage: 'Renew Policy'
    },
    DeclarationPage: {
        id: 'gateway.views.policy-detail-summary.Declaration page',
        defaultMessage: 'Declaration page'
    },
    IdCard: {
        id: 'gateway.views.policy-detail-summary.ID Card',
        defaultMessage: 'ID Card'
    },
    PolicyTransactions: {
        id: 'gateway.views.policy-detail.Policy Transactions',
        defaultMessage: 'Policy Transactions'
    },
    Details: {
        id: 'gateway.views.policy-detail.Details',
        defaultMessage: 'Details'
    },
    SummaryDetails: {
        id: 'gateway.views.policy-detail.Summary Details',
        defaultMessage: 'Summary Details'
    },
    SummaryDetailsPreRenewalDirectionNone: {
        id: 'gateway.views.policy-detail.None',
        defaultMessage: 'None'
    },
    ProducerInformation: {
        id: 'gateway.views.policy-detail.Producer Information',
        defaultMessage: 'Producer Information'
    },
    PolicyValue: {
        id: 'gateway.views.policy-detail.Policy Value',
        defaultMessage: 'Policy Value'
    },
    Coverages: {
        id: 'gateway.views.policy-detail.Coverages',
        defaultMessage: 'Coverages'
    },
    PolicyInception: {
        id: 'gateway.views.policy-detail-summary.Policy Inception',
        defaultMessage: 'Policy Inception'
    },
    PolicyExpiration: {
        id: 'gateway.views.policy-detail-summary.Policy Expiration',
        defaultMessage: 'Policy Expiration'
    },
    ProducerOfRecord: {
        id: 'gateway.views.policy-detail.Producer of Record',
        defaultMessage: 'Producer of Record'
    },
    PreRenewalDirection: {
        id: 'gateway.views.policy-detail-summary.Pre Renewal Direction',
        defaultMessage: 'Pre-Renewal Direction'
    },
    PolicyStatus: {
        id: 'gateway.views.policy-detail-summary.Policy Status',
        defaultMessage: 'Policy Status'
    },
    ProducerOfService: {
        id: 'gateway.views.policy-detail.Producer of Service',
        defaultMessage: 'Producer of Service'
    },
    TotalPremium: {
        id: 'gateway.views.policy-detail.Total Premium',
        defaultMessage: 'Total Premium'
    },
    TaxesAndFees: {
        id: 'gateway.views.renewal.renewal-summary.Taxes and Fees',
        defaultMessage: 'Taxes and Fees'
    },
    TotalCost: {
        id: 'gateway.views.renewal.renewal-summary.Total Cost',
        defaultMessage: 'Total Cost'
    },
    NoneRenew: {
        id: 'gateway.views.policy-detail-summary.None',
        defaultMessage: 'None'
    },
    vehicles: {
        id: 'policy.pa.directives.policy-vehicle-info.vehicles',
        defaultMessage: 'Vehicles'
    },
    make: {
        id: 'policy.pa.directives.policy-vehicle-info.make',
        defaultMessage: 'Make'
    },
    model: {
        id: 'policy.pa.directives.policy-vehicle-info.model',
        defaultMessage: 'Model'
    },
    year: {
        id: 'policy.pa.directives.policy-vehicle-info.year',
        defaultMessage: 'Year'
    },
    licensePlate: {
        id: 'policy.pa.directives.policy-vehicle-info.license plate',
        defaultMessage: 'License Plate'
    },
    hideVehicleCoverages: {
        id: 'policy.pa.directives.policy-vehicle-info.hide vehicle coverages',
        defaultMessage: 'Hide Vehicle Coverages'
    },
    showVehicleCoverages: {
        id: 'policy.pa.directives.policy-vehicle-info.show vehicle coverages',
        defaultMessage: 'Show Vehicle Coverages'
    },
    Coverage: {
        id: 'policy.pa.directives.policy-vehicle-info.coverage',
        defaultMessage: 'Coverage'
    },
    Deductible: {
        id: 'policy.pa.directives.policy-vehicle-info.deductible',
        defaultMessage: 'Deductible ($)'
    },
    Limits: {
        id: 'policy.pa.directives.policy-vehicle-info.limits',
        defaultMessage: 'Limits ($)'
    },
    PremiumBreakdown: {
        id: 'policy.pa.directives.policy-vehicle-info.premium breakdown',
        defaultMessage: 'Premium Breakdown'
    },
    DriverType: {
        id: 'policy.pa.directives.policy-vehicle-info.driver type',
        defaultMessage: 'Driver Type'
    },
    vehicleInfoType: {
        id: 'policy.pa.directives.policy-vehicle-info.type',
        defaultMessage: 'Type'
    },
    vehicleInfoPolicy: {
        id: 'policy.pa.directives.policy-vehicle-info.Policy',
        defaultMessage: 'Policy'
    },
    coveredDrivers: {
        id: 'policy.pa.directives.policy-driver-info.Covered Drivers',
        defaultMessage: 'Covered Drivers'
    },
    coveredDriversName: {
        id: 'policy.pa.directives.policy-driver-info.Name',
        defaultMessage: 'Name'
    },
    driverAssignment: {
        id: 'policy.pa.directives.policy-driver-info.Driver Assignment',
        defaultMessage: 'Driver Assignment'
    },
    driverAssignmentName: {
        id: 'policy.pa.directives.policy-driver-info.Driver',
        defaultMessage: 'Driver'
    },
    driverAssignmentType: {
        id: 'policy.pa.directives.policy-driver-info.Driver Type',
        defaultMessage: 'Driver Type'
    },
    coveredDriversLicense: {
        id: 'policy.pa.directives.policy-driver-info.License',
        defaultMessage: 'License'
    },
    dateOfBirth: {
        id: 'policy.pa.directives.policy-driver-info.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    licencePlate: {
        id: 'policy.pa.directives.policy-vehicle-info.license plate',
        defaultMessage: 'License Plate'
    },
    totalPremium: {
        id: 'integration.policy.directives.policy-coverages.Total Premium:',
        defaultMessage: 'Total Premium:'
    },
    LiabilityAndExtensions: {
        id: 'policy.ho.directives.policy-dwelling-info.LiabilityAndExtensions',
        defaultMessage: 'Liability and Extensions'
    },
    policyNamedInsured: {
        id: 'gateway.directives.policy-named-insured.Policy Named Insured',
        defaultMessage: 'Policy Named Insured'
    },
    insuredName: {
        id: 'gateway.directives.policy-named-insured.Insured Name',
        defaultMessage: 'Insured Name'
    },
    insuredAssignment: {
        id: 'gateway.directives.policy-named-insured.Insured Assignment',
        defaultMessage: 'Insured Assignment'
    },
    garagedAt: {
        id: 'gateway.policy.policy-vehicle-info.Garaged At',
        defaultMessage: 'Garaged At'
    } ,
    VICCCode: {
        id: 'gateway.policy.policy-vehicle-info.VICC Code',
        defaultMessage: 'VICC Code'
    },
    ownershipType: {
        id: 'gateway.policy.policy-vehicle-info.Ownership Type',
        defaultMessage: 'Ownership Type'
    },
     primaryUse: {
        id: 'gateway.policy.policy-vehicle-info.Primary Use',
        defaultMessage: 'Primary Use'
    },
    annualKilometers: {
        id: 'gateway.policy.policy-vehicle-info.Annual Kilometers',
        defaultMessage: 'Annual Kilometers'
    },
    dailyCommuteKM: {
        id: 'gateway.policy.policy-vehicle-info.Daily Commute KM (One Way)',
        defaultMessage: 'Daily Commute KM (One Way)'
    },
    businessPercentage: {
        id: 'gateway.policy.policy-vehicle-info.Business Percentage',
        defaultMessage: 'Business Percentage'
    },
    engineDisplacement: {
        id: 'gateway.policy.policy-vehicle-info.Engine Displacement (cc)',
        defaultMessage: 'Engine Displacement (cc)'
    },
    engineType: {
        id: 'gateway.policy.policy-vehicle-info.Engine Type',
        defaultMessage: 'Engine Type'
    },
    vehicleAppraisalDate: {
        id: 'gateway.policy.policy-vehicle-info.Vehicle Appraisal Date',
        defaultMessage: 'Vehicle Appraisal Date'
    },
    vehicleAppraisalAmount: {
        id: 'gateway.policy.policy-vehicle-info.Vehicle Appraisal Amount',
        defaultMessage: 'Vehicle Appraisal Amount'
    },
    trailerType: {
        id: 'gateway.policy.policy-vehicle-info.Trailer Type',
        defaultMessage: 'Trailer Type'
    },
  bodyStyle: {
        id: 'gateway.policy.policy-vehicle-info.Body Style',
        defaultMessage: 'Body Style'
    },
    NumberOfWheels: {
        id: 'gateway.policy.policy-vehicle-info.Number of Wheels',
        defaultMessage: 'Number of Wheels'
    }, 
    trailerSupplement: {
        id: 'gateway.policy.policy-vehicle-info.Trailer Supplement',
        defaultMessage: 'Trailer Supplement'
    },
    carryingCapacity : {
        id: 'gateway.policy.policy-vehicle-info.Carrying capacity of the automobile',
        defaultMessage: 'Trailer supplements the carrying capacity of the automobile'
    }, 
    noOfSeats: {
        id: 'gateway.policy.policy-vehicle-info.No. of Seats',
        defaultMessage: 'No. of Seats'
    }, 
    funeralDirectorVehicleType: {
        id: 'gateway.policy.policy-vehicle-info.Funeral Director Vehicle Type',
        defaultMessage: 'Funeral Director Vehicle Type'
    }, 
    policyPriNamedInsured: {
        id: 'gateway.policy.policy-named-insured.roles.PolicyPriNamedInsured',
        defaultMessage: 'Primary Named Insured'
    },
    policyAddlNamedInsured: {
        id: 'gateway.policy.policy-named-insured.roles.PolicyAddlNamedInsured',
        defaultMessage: 'Additional Named Insured'
    },

   commercialVehicleSupplement: {
        id: 'gateway.policy.policy-vehicle-info.Commercial Vehicle Supplement',
        defaultMessage: 'Commercial Vehicle Supplement'
    }, 
    Delivery: {
        id: 'gateway.policy.policy-vehicle-info.Delivery',
        defaultMessage: 'Delivery'
    }, 
    useOfVehicle: {
        id: 'gateway.policy.policy-vehicle-info.Use of Vehicle',
        defaultMessage: 'Use of Vehicle'
    }, 
   classOfUse: {
        id: 'gateway.policy.policy-vehicle-info.Class of Use',
        defaultMessage: 'Class of Use'
    }, 
    radiusOfOperations: {
        id: 'gateway.policy.policy-vehicle-info.Radius of Operations',
        defaultMessage: 'Radius of Operations'
    }, 
    seasonalDelivery: {
        id: 'gateway.policy.policy-vehicle-info.Seasonal Delivery',
        defaultMessage: 'Seasonal Delivery'
    }, 
    haulNonOwnedTrailers: {
        id: 'gateway.policy.policy-vehicle-info.Haul Non-Owned Trailers',
        defaultMessage: 'Haul Non-Owned Trailers'
    }, 
    CVORDetails: {
        id: 'gateway.policy.policy-vehicle-info.CVOR Details',
        defaultMessage: 'CVOR Details'
    }, 
    CVORNumber: {
        id: 'gateway.policy.policy-vehicle-info.CVOR Number',
        defaultMessage: 'CVOR Number'
    }, 
    CVORRating: {
        id: 'gateway.policy.policy-vehicle-info.CVOR Rating',
        defaultMessage: 'CVOR Rating'
    }, 
    CVORViolationRate: {
        id: 'gateway.policy.policy-vehicle-info.CVOR Violation Rate (%)',
        defaultMessage: 'CVOR Violation Rate (%)'
    }, 
    CVORReportDate: {
        id: 'gateway.policy.policy-vehicle-info.CVOR Report Date',
        defaultMessage: 'CVOR Report Date'
    }, 
    CVORReOrderDate: {
        id: 'gateway.policy.policy-vehicle-info.CVOR Re-Order Date',
        defaultMessage: 'CVOR Re-Order Date'
    },
    totalTax: {
        id: 'gateway.views.renewal.renewal-summary.Taxes',
        defaultMessage: 'Taxes'
    },  
    totalFees: {
        id: 'gateway.views.renewal.renewal-summary.Fees',
        defaultMessage: 'Fees'
    },
    taxesAndFees: {
        id: 'gateway.views.renewal.renewal-summary.Taxes and Fees',
        defaultMessage: 'Taxes and Fees'
    },
    vehcileDrivingRecord: {
        id: 'policy.pa.directives.policy-driver-info.Driving Record',
        defaultMessage: 'Driving Record'
    },
    driverAssignmentPremium: {
        id: 'policy.pa.directives.policy-driver-info.Premium',
        defaultMessage: 'Premium ($)'
    },
    PremiumAmount: {
        id: 'gateway.directives.policy-transaction.PremiumNoCurrency',
        defaultMessage: 'Premium'
    },
    drivingRecord: {
        id: 'quoteandbind.common.policy-info.Driving record',
        defaultMessage: 'Driving record'
    },
    territoryInfo: {
        id: 'quoteandbind.common.policy-info.Territory',
        defaultMessage: 'Territory'
    },
    multipleDraftsError: {
        id: 'quoteandbind.common.policy-info.multipleDraftsError',
        defaultMessage: 'Multiple Draft Policy Changes exist on this policy, please withdraw the transactions or contact your Underwriter for support.'
    },
    modelError: {
        id: 'quoteandbind.common.policy-info.modelError',
        defaultMessage: 'Error'
    },
    cancellationDocTitle: {
        id: 'policyChange.common.policy.Warning',
        defaultMessage: 'Warning'
    },
    cancellationDocMessage:{
        id: 'policyChange.common.policy.Cancellation form signed by Insured(s) must be attached with this request',
        defaultMessage: 'Cancellation form signed by Insured(s) must be attached with this request'
    },
});
